// ------------------------------------------------------------------------------------------------------------------------------------
// Cookie Function
// ------------------------------------------------------------------------------------------------------------------------------------

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function deleteCookie(name) {
    setCookie(name, false, 1);
}

/*
function checkCookie() {
    let user = getCookie("username");
    if (user != "") {
        alert("Welcome again " + user);
    } else {
        user = prompt("Please enter your name:", "");
        if (user != "" && user != null) {
            setCookie("username", user, 365);
        }
    }
}
*/


// ------------------------------------------------------------------------------------------------------------------------------------
// VAT Toggle
// ------------------------------------------------------------------------------------------------------------------------------------

var body = document.body;

// Check cookie on page load
var vatCookie = getCookie("ex-vat");
if (vatCookie && vatCookie === 'true') {
  body.classList.add('ex-vat');
} else{
  body.classList.add('inc-vat');
}

/*
if (body.classList.contains('trade-customer')) {
  body.classList.add('ex-vat');
  body.classList.remove('inc-vat');
}
*/

var vatToggle = document.querySelector('.header__vat--toggle');

vatToggle.addEventListener('click', function(e){
  body.classList.toggle('ex-vat');
  body.classList.toggle('inc-vat');

  // Get the current cookie again
  var vatCookie = getCookie("ex-vat");

  if (vatCookie && vatCookie === 'true') {
    // Remove Cookie
    deleteCookie("ex-vat");
  } else {
    // Set Cookie
    setCookie("ex-vat", 'true', 1);
  }
});

document.querySelector('.header__vat').style.visibility = 'visible';


// ------------------------------------------------------------------------------------------------------------------------------------
// Menu
// ------------------------------------------------------------------------------------------------------------------------------------

// Touch

var body = document.getElementsByTagName('body')[0];
if ( !("ontouchstart" in body) ) {
    body.className += (body.className?" ":"") + "no-touch";
} else {
    body.className += (body.className?" ":"") + "has-touch";
}

// Menu hover

if ( !("ontouchstart" in body) ) {
  let items = document.querySelector(".list-menu--inline").querySelectorAll("details");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {

      const myTimeout = setTimeout(hover, 100);

      function hover() {

        item.setAttribute("open", true);
        item.querySelector(".header__subdropdown").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });

      }

      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
        clearTimeout(myTimeout);
      });

    });
  });
}


// ------------------------------------------------------------------------------------------------------------------------------------
// USP slider 
// ------------------------------------------------------------------------------------------------------------------------------------

var uspSlider = document.querySelectorAll('.usp-wrapper');
if ( uspSlider ){
  uspSlider.forEach(slider => {
    var flkty = new Flickity( slider, {
      // options
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      autoPlay: 3000,
      watchCSS: true,
      pauseAutoPlayOnHover: false
    });
  });
}


// ------------------------------------------------------------------------------------------------------------------------------------
// Footer menu expand 
// ------------------------------------------------------------------------------------------------------------------------------------

var footerHeadings = document.querySelectorAll('.footer-block--menu .footer-block__heading');

footerHeadings.forEach(heading =>{

  heading.addEventListener('click', (e) => {

    if ( window.innerWidth < 750 ) {
      const next = e.currentTarget.nextElementSibling;

      if (next.classList.contains('open')) {
        next.classList.remove('open');
      } else {
        next.classList.add('open');
      }
      
    }

  });
  
});


// ------------------------------------------------------------------------------------------------------------------------------------
// Scroll Up
// ------------------------------------------------------------------------------------------------------------------------------------

var scrollTopBtn = document.getElementById('scroll-top');

if ( window.scrollY > 0 ){
  scrollTopBtn.classList.remove('hide');
}

scrollTopBtn.addEventListener("click", function() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  setTimeout(function(){
    scrollTopBtn.classList.add('hide');
  }, 500);
});


var scrollableElement = window;

scrollableElement.addEventListener('scroll', checkScroll);

function checkScroll(event) {
    console.log('scroll');
    scrollTopBtn.classList.remove('hide');

    if ( window.scrollY === 0 ){
      scrollTopBtn.classList.add('hide');
    }
}


// ------------------------------------------------------------------------------------------------------------------------------------
// Scroll Up
// ------------------------------------------------------------------------------------------------------------------------------------
/*
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});
*/



// ------------------------------------------------------------------------------------------------------------------------------------
// Trade Prices
// ------------------------------------------------------------------------------------------------------------------------------------

var isoCode = body.dataset.isoCode;

if ( body.classList.contains('trade-customer') && isoCode == "GBP" && !window.location.href.includes('quick-order-form') ) {

  //const processed = new WeakSet();

  function handleMoney(el) {
      //if (processed.has(el)) return;
      //processed.add(el);
      if (el.classList.contains("ex-vat-price")) return;

      //console.log("Money element added:", el);

      el.classList.add('ex-vat-price');

      const rrp = el.nextElementSibling?.matches("s")
      ? el.nextElementSibling
      : null;

      if (rrp) {
        const rrpPrice = parseFloat(rrp.textContent.replace(/[£,]/g, ""));
        if (!Number.isNaN(rrpPrice)) {

          rrp.classList.add("ex-vat-price");
          
          const rrpVat = (rrpPrice * 1.2).toFixed(2);

          const s = document.createElement("s");
          s.className = "inc-vat-price";
          s.textContent = "£" + rrpVat;

          rrp.insertAdjacentElement("afterend", s);
          
        }
      }

      const elPrice = parseFloat(el.textContent.replace(/[£,]/g, ""));
      const elVat = (elPrice * 1.2).toFixed(2);

      const span = document.createElement("span");
      span.className = "inc-vat-price";
      span.textContent = "£" + elVat;

      el.insertAdjacentElement("afterend", span);
  }

  const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
              if (node.nodeType !== Node.ELEMENT_NODE) continue;

              // The added node itself
              if (node.matches(".money")) {
                  handleMoney(node);
              }

              // Any .money elements inside the added node
              node.querySelectorAll(".money").forEach(handleMoney);
          }
      }
  });

  observer.observe(document.body, {
      childList: true,
      subtree: true
  });

}






if ( window.location.href.includes('quick-order-form') && isoCode == "GBP" ) {
  //const processed = new WeakSet();

  function handleMoney(el) {
      //if (processed.has(el)) return;
      //processed.add(el);
      if (el.classList.contains("ex-vat-price")) return;

      //console.log("Money element added:", el);

      el.classList.add('ex-vat-price');

      const rrp = el.nextElementSibling?.matches("s")
      ? el.nextElementSibling
      : null;

      if (rrp) {
        const rrpPrice = parseFloat(rrp.textContent.replace(/[£,]/g, ""));
        if (!Number.isNaN(rrpPrice)) {

          rrp.classList.add("ex-vat-price");
          
          const rrpVat = (rrpPrice * 1.2).toFixed(2);

          const s = document.createElement("s");
          s.className = "inc-vat-price";
          s.textContent = "£" + rrpVat;

          rrp.insertAdjacentElement("afterend", s);
          
        }
      }

      const priceMatch = el.textContent.match(/£([\d,]+(?:\.\d+)?)/);

      if (priceMatch) {
          const elPrice = parseFloat(priceMatch[1].replace(/,/g, ""));

          if (!Number.isNaN(elPrice)) {
              const elVat = (elPrice * 1.2).toFixed(2);

              const prefix = el.querySelector("span")?.textContent.trim();
              const span = document.createElement("span");

              span.className = "inc-vat-price";
              span.textContent = (prefix ? prefix + " " : "") + "£" + elVat;

              el.insertAdjacentElement("afterend", span);
          }
      }
  }

  const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
              if (node.nodeType !== Node.ELEMENT_NODE) continue;

              // The added node itself
              if (node.matches(".money")) {
                  handleMoney(node);
              }

              // Any .money elements inside the added node
              node.querySelectorAll(".money").forEach(handleMoney);
          }
      }
  });

  observer.observe(document.body, {
      childList: true,
      subtree: true
  });

  document.querySelectorAll(".pri").forEach(handleMoney);

}